import React from 'react';
import { Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FaWrench, FaSolarPanel, FaTachometerAlt, FaWater } from 'react-icons/fa';
import './projects.css'

const projects = [
  {
    icon: <FaWater />,
    title: "Manduwasa Water Supply Installation",
    description: "Complete water supply system installation including pipeline layout, pump installation, and system commissioning.",
    tags: ["Water Supply", "Installation"],
    image: "/images/9.jpeg"
  },
  {
    icon: <FaSolarPanel />,
    title: "Manduwasa Solar-Powered Water Supply System (Baseflow)",
    description: "Solar-powered water supply system implementation under the Baseflow project.",
    tags: ["Solar", "Baseflow"],
    image: "/images/10.jpeg"
  },
  {
    icon: <FaSolarPanel />,
    title: "Rehabilitation of Solar-Powered Water System",
    description: "Rehabilitation works to restore performance and reliability of an existing solar-powered water supply system.",
    tags: ["Solar", "Rehabilitation"],
    image: "/images/11.jpeg"
  },
  {
    icon: <FaTachometerAlt />,
    title: "Water Meter Installation – Dowa District",
    description: "Installation of 100 water meters on Afridev boreholes under Self Help Africa Water Carbon Project, including fabrication of protection boxes and calibration.",
    tags: ["Meters", "Dowa"],
    image: "/images/12.jpeg"
  },
  {
    icon: <FaWrench />,
    title: "Borehole Pump Installations (Multiple Sites)",
    description: "Installation and servicing of submersible pumps across multiple rural communities.",
    tags: ["Pumps", "Maintenance"],
    image: "/images/13.jpeg"
  },
  {
    icon: <FaWrench />,
    title: "Fabrication Works",
    description: "Design and fabrication of steel structures, meter boxes, tanks, and custom mechanical components for water systems.",
    tags: ["Fabrication", "Welding"],
    image: "/images/14.jpeg"
  }
];

function Projects() {
  return (
    <section className="projects-page">
      <Container>
        <div className="projects-hero">
          <div className="projects-hero-left">
            <div className="projects-pill">★ PROJECTS</div>
            <h2 className="projects-title">Completed Projects & Field Work</h2>
            <p className="projects-subtitle">
              A snapshot of recent installations, rehabilitation works, metering, and fabrication delivered by DTE.
            </p>
            <Link to="/quote" className="projects-cta">Request a Quote</Link>
          </div>

          <div className="projects-hero-right" aria-hidden="true">
            <img className="projects-hero-image" src="/images/32.jpg" alt="" />
          </div>
        </div>

        <div className="projects-grid">
          {projects.map((project, idx) => (
            <article
              key={idx}
              className={`project-card ${idx === 0 ? 'project-card--featured' : ''}`}
            >
              <div
                className="project-hover-image"
                aria-hidden="true"
                style={{ '--hover-img': `url(${project.image})` }}
              />
              <div className="project-top">
                <div className="project-number">{String(idx + 1).padStart(2, '0')}</div>
                <div className="project-icon">{project.icon}</div>
              </div>

              <h3 className="project-title">{project.title}</h3>
              <p className="project-description">{project.description}</p>

              <div className="project-tags">
                {(project.tags || []).map((tag) => (
                  <span className="project-tag" key={tag}>{tag}</span>
                ))}
              </div>
            </article>
          ))}
        </div>
      </Container>
    </section>
  );
}

export default Projects;